/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_transactions_table_method = /** @type {(inputs: {}) => string} */ () => {
	return `Método`
};

const en_cards_transactions_table_method = /** @type {(inputs: {}) => string} */ () => {
	return `Method`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_transactions_table_method = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_transactions_table_method(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_transactions_table_method", locale)
	if (locale === "es") return es_cards_transactions_table_method(inputs)
	return en_cards_transactions_table_method(inputs)
};
export { cards_transactions_table_method as "cards.transactions.table.method" }